/**
 * Business Detail Page
 */

import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const BusinessDetail: React.FC = () => {
  const { id } = useParams();

  return (
    <div>
      <Link to="/businesses" style={styles.backLink}>
        <ArrowLeft size={20} /> Back to Businesses
      </Link>
      
      <h1 style={styles.title}>Business Details</h1>
      <p style={{ color: '#9ca3af' }}>Business ID: {id}</p>
      
      {/* TODO: Load and display full business details */}
      <div style={styles.card}>
        <p>Business detail page - Coming soon</p>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  backLink: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: '#9ca3af',
    textDecoration: 'none',
    marginBottom: '20px',
  },
  title: {
    fontSize: '2rem',
    fontWeight: 700,
    color: '#fff',
    margin: '0 0 10px 0',
  },
  card: {
    background: '#1a1a2e',
    borderRadius: '12px',
    padding: '24px',
    border: '1px solid #252540',
    marginTop: '20px',
  },
};

export default BusinessDetail;
